module.exports = __webpack_public_path__ + "img/lift-panel-xray.cd2b93d4.jpg";